import * as React from "react";
import { useState } from "react";
import useFilterValueSuggestions from "components/common/EntityFilters/hooks/useFilterValueSuggestions";
import SuggestionsList from "./SuggestionsList";
const DEFAULT_SEARCH_PARAMS = {
  query: "",
  pageSize: 10,
  page: 1
};
const SuggestionsListFilter = ({ attribute, filterValueRenderer, onSubmit, allActiveFilters, multiSelect }) => {
  const [searchParams, setSearchParams] = useState(DEFAULT_SEARCH_PARAMS);
  const {
    data: { pagination, suggestions },
    isInitialLoading
  } = useFilterValueSuggestions(attribute.id, attribute.related_collection, searchParams, attribute.related_property);
  return /* @__PURE__ */ React.createElement(
    SuggestionsList,
    {
      isLoading: isInitialLoading,
      total: pagination.total,
      pageSize: searchParams.pageSize,
      page: searchParams.page,
      setSearchParams,
      allActiveFilters,
      attribute,
      multiSelect,
      filterValueRenderer,
      onSubmit,
      suggestions
    }
  );
};
export default SuggestionsListFilter;
